import * as React from 'react'
import colors from '../../globals/colors'
import { IsMobile, RETURN_TO_DASHBAORD, RETURN_TO_DASHBAORD_QUERY, useQuery, useWindowSize } from '../../globals/UIHooks'
import Stepper from '../atoms/Stepper'
import { RowFlexBox } from '../templates/Wrappers'
//@ts-ignore
import { ReactComponent as BackIcon } from '../../assets/icon/back-icon.svg';
import { lang } from '../../globals/Translations'
import { TranslatedTerms } from '../../globals/TranslatedTerms'


type Props = {
    steps: string[], activeStepIndex: number, id?: string, pathExtention?: string,
    title: string, loading: boolean
}

const stepPrefix = "step"
export const StepPageHeader: React.FC<Props> = ({ steps, activeStepIndex, id, title, loading, pathExtention }) => {
    const { width } = useWindowSize()
    const goBackToDashboard = (useQuery()).get("source") === RETURN_TO_DASHBAORD
    const location = (useQuery()).get("step")

    React.useEffect(()=> {
        if(loading) return;
        if(location === null || !pathExtention || location !== pathExtention){
            var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?'+stepPrefix+'='+pathExtention
            if(goBackToDashboard) newurl = newurl + '&'+ RETURN_TO_DASHBAORD_QUERY
            window.history.pushState({path:newurl},'',newurl);        
        }
    },[location, loading, pathExtention])

    const returnUrl = goBackToDashboard?'/':'/projects/' + id

    return (
        <RowFlexBox style={{
            width: '100%', minHeight: IsMobile(width) ? 130 : 80, boxShadow: colors.defaultShadow,
            alignItems: 'center', position: 'fixed', top: 0, zIndex: 114, backgroundColor: colors.lightest
        }}>
            <div style={{ padding: 10 }}>
                <a href={returnUrl} style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', textDecoration: 'none' }}>
                    <BackIcon height={20} fill={colors.dark} />  
                    {!IsMobile(width) && lang(goBackToDashboard?TranslatedTerms.GO_TO_DASHBOARD:TranslatedTerms.GO_TO_PROJECT).toUpperCase()}
                </a>
            </div>
            <div>
                <h5 style={{ margin: 0, fontSize: IsMobile(width) ? 14 : 18 }}>{title}</h5>
                {!loading && <Stepper steps={steps} activeStepIndex={activeStepIndex} />}
            </div>
        </RowFlexBox>
    )
}
